import useHttpPost from "./useHttpPost";

function usePostTransaction(target) {
  return useHttpPost("targetlatest", "post", {}, target);
}

export default usePostTransaction;
